/** No-op function. Returns `null` to satisfy most React typings. */
export function noop(): null {
  return null
}
